
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.7523 14.5718C16.0763 14.8958 16.0774 15.42 15.7497 15.7477C15.4243 16.0732 14.8983 16.0749 14.5738 15.7503L10.0497 11.2263C8.99823 12.0296 7.68424 12.5068 6.25879 12.5068C2.80701 12.5068 0.00878906 9.70862 0.00878906 6.25684C0.00878906 2.80506 2.80701 0.00683594 6.25879 0.00683594C9.71057 0.00683594 12.5088 2.80506 12.5088 6.25684C12.5088 7.68228 12.0316 8.99627 11.2282 10.0478L15.7523 14.5718ZM6.25879 10.8402C8.79009 10.8402 10.8421 8.78814 10.8421 6.25684C10.8421 3.72553 8.79009 1.6735 6.25879 1.6735C3.72748 1.6735 1.67546 3.72553 1.67546 6.25684C1.67546 8.78814 3.72748 10.8402 6.25879 10.8402Z"}})])
          )
        }
      }
    